/** @format */

import { memo, useState } from "react";
import styled from "styled-components";

import ExpensesFilter from "./ExpensesFilter";
import ExpensesList from "./ExpensesList";

const Expenses = ({ items }) => {
	const [filteredYear, setFilteredYear] = useState("2020");

	const filterChangeHandler = (selectedYear) => {
		setFilteredYear(selectedYear);
	};

	const filteredExpense = items?.filter((expense) => {
		return expense.date.getFullYear().toString() === filteredYear;
	});

	return (
		<ExpensesWrapper>
			<ExpensesFilter
				selected={filteredYear}
				onFilterChange={filterChangeHandler}
			/>
			<ExpensesList filteredExpense={filteredExpense} />
		</ExpensesWrapper>
	);
};

export default memo(Expenses);

const ExpensesWrapper = styled.div`
	padding: 1rem;
	background-color: rgb(31, 31, 31);
	margin: 2rem auto;
	width: 50rem;
	max-width: 95%;
	border-radius: 12px;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.25);
`;
